import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Page from "../components/Page";
import {
  verifyActivationLink,
  verifyActivationLinkClear,
} from "../redux/auth/actions";
import { useNavigate } from "react-router-dom";
import { isAndroid, isIOS } from "react-device-detect";
import CONFIG from "../utils/config";
import FooterNew from "../components/FooterNew";
import HeaderLogoSection from "../components/HeaderLogoSection";
import Loader from "../components/Loader/Loader";
import MESSAGE from "../utils/messages";
import { isMainDomain } from "../utils/AppUtils";

const VerifyEmailPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const email = paramsReq.email;
  const key = paramsReq.key;
  const action = paramsReq.action;
  // const email = params.get('email');
  // const key = params.get('key');
  // const action = params.get('action');
  const role = params.get('role');
  const verifyLink = useSelector(state => state.auth.verifyLink)
  const [showConfirmBox, setShowConfirmBox] = useState(false)
  const [isUserActive, setIsUserActive] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    dispatch(
      verifyActivationLink({
        module: "setpassword",
        postData: {
          email: email,
          token: key,
        },
      })
    );
    return () => {
      dispatch(verifyActivationLinkClear());
    };
  }, [dispatch]);

  useEffect(() => {
    // if ((isAndroid || isIOS) && CONFIG.ENV != 'DEV') {
    if (false) {
      setShowConfirmBox(true);
    }
  }, [isAndroid, isIOS]);

  useEffect(() => {
    // if ((isAndroid || isIOS) && CONFIG.ENV != 'DEV') {
    if (false) {
      setShowConfirmBox(true)
    }
  }, [isAndroid, isIOS])


  useEffect(() => {
    console.log("verifylink", verifyLink);
    // return;
    if (!_.isEmpty(verifyLink)) {
      // if ((!(isAndroid || isIOS) && CONFIG.ENV === 'DEV')) {
      if (true) {
        if (verifyLink.status === "success") {
          const verifyLinkData = verifyLink.payload.payload;
          if (!_.isEmpty(verifyLinkData)) {
            const isTokenValid = verifyLinkData.token;
            const isActive = verifyLinkData.active;
            if (isTokenValid) {
              if (isActive) {
                if (action === "reset") {
                  navigate(`/resetPass?email=${email}&key=${key}&action=reset`);
                } else {
                  setIsUserActive(true);
                }
              } else {
                if (action === "reset") {
                  //  navigate("/",{state:{ resetTokenExpired: true}})
                  navigate(
                    `/activation-expiry?email=${email}&key=${key}&action=${action}`
                  );
                }if (action === "email-verified") {
                  navigate(`/sign-up?p=4&email=${email}&token=${key}&from=email`)
                } else {
                  navigate(
                    `/setup-password?email=${email}&key=${key}&action=updatepassword`
                  );
                }
              }
            } else {
              if (isActive) {
                if (action === "reset") {
                  navigate(
                    `/activation-expiry?email=${email}&key=${key}&action=${action}`
                  );
                } else {
                  setIsUserActive(true);
                }
              } else {
                if (action === "reset") {
                  // navigate("/",{state:{ resetTokenExpired: true}})
                  navigate(
                    `/activation-expiry?email=${email}&key=${key}&action=${action}`
                  );
                } else {
                  navigate(
                    `/activation-expiry?email=${email}&key=${key}&action=${action}`
                  );
                }
              }
            }
          }
          // setShowConfirmBox(true)
        } else {
          if (action != "reset") {
            navigate(
              `/activation-expiry?email=${email}&key=${key}&action=${action}`
            );
          } else {
            navigate(
              `/activation-expiry?email=${email}&key=${key}&action=${action}`
            );
            // navigate("/",{state:{ resetTokenExpired: true}})
          }
        }
        setIsLoading(false);
      } else {
        if (verifyLink.status === "success") {
          const verifyLinkData = verifyLink.payload.payload;
          if (!_.isEmpty(verifyLinkData)) {
            const isTokenValid = verifyLinkData.token;
            const isActive = verifyLinkData.active;
            if (!isTokenValid) {
              navigate(
                `/activation-expiry?email=${email}&key=${key}&action=${action}`
              );
            }
          }
          // setShowConfirmBox(true)
        }
        setIsLoading(false);
      }
      setIsLoading(false);
      // console.log('not empty')
    }
  }, [verifyLink]);

  const proceedToWeb = () => {
    if (verifyLink.status === "success") {
      if (action === "setpassword") {
        navigate(
          `/setup-password?email=${email}&key=${key}&action=updatepassword`
        );
      } else if (action === "reset") {
        navigate(`/resetPass?email=${email}&key=${key}&action=reset`);
      }
      // navigate(`/setup-password?email=${email}&key=${key}&action=updatepassword`)
    } else {
      navigate(`/activation-expiry?email=${email}&key=${key}&action=${action}`);
    }
    return "";
  };

  const proceedToApp = () => {
    if (verifyLink.status === "success") {
      if (isAndroid) {
        let url;
        if (action === "setpassword") {
          url = `Xsel://http?clicked_from=setup_password&user_name=${email}&token=${key}`;
        } else if (action === "reset") {
          url = `Xsel://http?clicked_from=reset_password&user_name=${email}&token=${key}`;
        }

        window.location.replace(url);
        // setTimeout(() => {

        //navigate(`/setup-password?email=${email}&key=${key}&action=updatepassword`)
        //   }, 1000);
      } else if (isIOS) {
        let url;
        if (action === "setpassword") {
          url = `Xsel://?clicked_from=setup_password&user_name=${email}&token=${key}`;
        } else if (action === "reset") {
          url = `Xsel://?clicked_from=reset_password&user_name=${email}&token=${key}`;
        }

        window.location.replace(url);
        // setTimeout(() => {
        //navigate(`/setup-password?email=${email}&key=${key}&action=updatepassword`)

        // }, 1000);
      }
    } else {
      if (isAndroid) {
        let url;
        if (action === "setpassword") {
          url = `Xsel://http?clicked_from=resend_link&user_name=${email}&token=${key}`;
        } else if (action === "reset") {
          url = `Xsel://http?clicked_from=reset_link_fail&user_name=${email}&token=${key}`;
        }

        window.location.replace(url);
        // setTimeout(() => {
        //navigate(`/activation-expiry?email=${email}&key=${key}&action=${action}`)

        //   }, 1000);
      } else if (isIOS) {
        let url;
        if (action === "setpassword") {
          url = `Xsel://?clicked_from=resend_link&user_name=${email}&token=${key}`;
        } else if (action === "reset") {
          url = `Xsel://?clicked_from=reset_link_fail&user_name=${email}&token=${key}`;
        }

        // `Xsel://`;

        window.location.replace(url);
        // setTimeout(() => {
        //navigate(`/activation-expiry?email=${email}&key=${key}&action=${action}`)

        // }, 1000);
      }
    }
  };

  return (
    <>
      {/* Create Mediator Page */}
      <div className="login-ary setup-password">
        <section className="login-sec ">
          <div className="login-container ">
            {/* <div className="bannerlog-image d-block d-md-none image-login">
              <img className="img-fluid" src="images/login_img.jpg" />
            </div> */}
            <div className="container-fluid">
              <div className="row bglogin">
                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                  <img
                    className="img-fluid"
                    src="images/login_img.jpg"
                    alt="home-scene-login"
                  />
                </div>
                <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
                  <div className="login-text">
                    <div className="text-center lgo-box">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_3752_2008)">
                          <rect
                            x="2"
                            y="1"
                            width="56"
                            height="56"
                            rx="12"
                            fill="white"
                          />
                          <rect
                            x="2.5"
                            y="1.5"
                            width="55"
                            height="55"
                            rx="11.5"
                            stroke="#EAECF0"
                          />
                          <path
                            d="M18.334 23.1641L27.8597 29.8321C28.6311 30.372 29.0168 30.642 29.4363 30.7466C29.8069 30.839 30.1944 30.839 30.565 30.7466C30.9845 30.642 31.3702 30.372 32.1416 29.8321L41.6673 23.1641M23.934 38.3307H36.0673C38.0275 38.3307 39.0076 38.3307 39.7563 37.9493C40.4149 37.6137 40.9503 37.0783 41.2858 36.4197C41.6673 35.671 41.6673 34.6909 41.6673 32.7307V25.2641C41.6673 23.3039 41.6673 22.3238 41.2858 21.5751C40.9503 20.9165 40.4149 20.3811 39.7563 20.0455C39.0076 19.6641 38.0275 19.6641 36.0673 19.6641H23.934C21.9738 19.6641 20.9937 19.6641 20.245 20.0455C19.5865 20.3811 19.051 20.9165 18.7155 21.5751C18.334 22.3238 18.334 23.3039 18.334 25.2641V32.7307C18.334 34.6909 18.334 35.671 18.7155 36.4197C19.051 37.0783 19.5865 37.6137 20.245 37.9493C20.9937 38.3307 21.9738 38.3307 23.934 38.3307Z"
                            stroke="#344054"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_3752_2008"
                            x="0"
                            y="0"
                            width="60"
                            height="60"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_3752_2008"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_3752_2008"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                    {false ? (
                      <>
                        {showConfirmBox && !isUserActive ? (
                          <div className="row mt-2">
                            <div className="col-12">
                              <div className="borderboxsec">
                                <div className="row">
                                  <div className="col-12 mb-3 d-flex justify-content-center hedig">
                                    How would you like to proceed?
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-6">
                                    <button
                                      className="btn-order btn-primary onbtn"
                                      onClick={() => proceedToWeb()}
                                    >
                                      On Web App
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      className="btn-order btn-primary onbtn"
                                      onClick={() => proceedToApp()}
                                    >
                                      On Mobile App
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )}

                    {isUserActive ? (
                      action === "reset" ? (
                        <p><strong>{MESSAGE.LINK_EXPIRED}</strong></p>
                      ) : (
                        <div className="row">
                          <div className="col-md-12 mt-2">
                            <p className="text-center">
                              <strong>{MESSAGE.LINK_EXPIRED}</strong>
                            </p>
                            <p className="text-center">
                              <strong> If password setup is already completed, please
                                click&nbsp;
                                <u
                                  style={{ color: "royalblue" }}
                                  onClick={() =>{
                                    if(isMainDomain()){
                                      navigate("/verify-user")
                                    }else{
                                      navigate("/")
                                    }
                                    // navigate("/login")
                                  }}
                                  className="cursor-pointer"
                                >
                                  here
                                </u>
                                &nbsp;to Sign in</strong>
                            </p>
                            {/* <p>
                                <i style={{'fontWeight':'100'}}>
                                    <br />Incase, you have forgotten, click on forgot password link on login page.
                                </i>
                            </p> */}
                            {/* <p><i style={{'fontWeight':'100'}}>You can regenerated by clicking on <u style={{ color: 'royalblue' }} onClick={() => resend()} className="cursor-pointer">resend verification</u> link.</i></p> */}
                          </div>
                        </div>
                      )
                    ) : (
                      ""
                    )}
                    {/* <p className="text-center cursor-pointer mt-4 pt-2 bck-login">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M16.3327 9.9974H4.66602M4.66602 9.9974L10.4993 15.8307M4.66602 9.9974L10.4993 4.16406"
                          stroke="#475467"
                          strokeWidth="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>{" "}
                      {"Back to log in"}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VerifyEmailPage;
